const GET_TREEVIEW_SUCCESS = "GET_TREEVIEW_SUCCESS";
const GET_TREEVIEW_FAIL = "GET_TREEVIEW_FAIL";
const JOB_ORDER_CHANGE_SUCCESS = "JOB_ORDER_CHANGE_SUCCESS";
const POST_TREEVIEW_CHANGE_SUCCESS = "POST_TREEVIEW_CHANGE_SUCCESS";
const POST_TREEVIEW_CHANGE_FAIL = "POST_TREEVIEW_CHANGE_FAIL";
const POST_TREEVIEW_CHANGE = "POST_TREEVIEW_CHANGE";
const NEW_TREEVIEW_NODE_SUCCESS = "NEW_TREEVIEW_NODE_SUCCESS";
const NODE_EXPANDED_SUCCESS = "NODE_EXPANDED_SUCCESS";
const NODE_INCLUDELOWERRECORDS_SUCCESS = "NODE_INCLUDELOWERRECORDS_SUCCESS";
const NODE_RENAMED_SUCCESS = "NODE_RENAMED_SUCCESS";
const NODE_RENAMED_FAIL = "NODE_RENAMED_FAIL";
const REMOVE_TREEVIEW_NODE_SUCCESS = "REMOVE_TREEVIEW_NODE_SUCCESS";
const NODE_MOVED_TO_VAULT_SUCCESS = "NODE_MOVED_TO_VAULT_SUCCESS";
const NODE_MOVED_SUCCESS = "NODE_MOVED_SUCCESS";
const NODE_MOVED_FAIL = "NODE_MOVED_FAIL";
const GET_NODE_NOTE_SUCCESS = "GET_NODE_NOTE_SUCCESS";
const ADD_NODE_NOTE_SUCCESS = "ADD_NODE_NOTE_SUCCESS";
const LOWER_RECORDS_CHECKED = "LOWER_RECORDS_CHECKED";
const SET_SELECTED_NODE_SUCCESS = "SET_SELECTED_NODE_SUCCESS";
const SET_NODE_IDS = "SET_NODE_IDS";
const TREEVIEW_TESTS_MOVE_SUCCESS = "TREEVIEW_TESTS_MOVE_SUCCESS";
const TREEVIEW_TESTS_MOVE_FAIL = "TREEVIEW_TESTS_MOVE_FAIL";
const TREEVIEW_EDIT_JOB_SET = "TREEVIEW_EDIT_JOB_SET";
const TREEVIEW_EDIT_JOB_RESET = "TREEVIEW_EDIT_JOB_RESET";
const SET_JOBS_TABLE_CHANGED = "SET_JOBS_TABLE_CHANGED";
const SET_MONITORING_JOBS_TABLE_CHANGE = "SET_MONITORING_JOBS_TABLE_CHANGE";

export const defaultTreeState = {
    treeviewData: {},
    nodeSelectedIds: null,
    editTreeviewJobId: -1,
    jobsTableChanged: null,
    monitoringJobsTableChange: null,
};

export default (state = defaultTreeState, action) => {
    switch(action.type){
        case "TREEVIEW":
            return state;
        case GET_TREEVIEW_SUCCESS:
        case JOB_ORDER_CHANGE_SUCCESS:
            const s = {...state};
            s.treeData = {};
            return {
                ...s,
                treeData: action.payload.data
            };
        case GET_TREEVIEW_FAIL:
        case NODE_MOVED_FAIL:
        case TREEVIEW_TESTS_MOVE_FAIL:
            return {
                ...state
            };
        case NODE_MOVED_TO_VAULT_SUCCESS:
        case SET_SELECTED_NODE_SUCCESS:
            return {
                ...state
            };
        case NODE_MOVED_SUCCESS:
            const nodeMovedState = {...state};
            nodeMovedState.treeData = {};
                return {
                    ...nodeMovedState,
                    treeData: action.payload.data
                };
        case TREEVIEW_TESTS_MOVE_SUCCESS:
            const testsMovedState = {...state};
            testsMovedState.treeData = {};
                return {
                    ...testsMovedState,
                    treeData: action.payload.data
                };
        case POST_TREEVIEW_CHANGE:{
            const  treeviewState  = action.data;

        const recursiveFunc = (treeData) => {
            if(treeData.children){
               //filter treeData.children
               const children = treeData.children.filter(child => {
                if(child.type === 'test' || child.type === 'tests'){
                  // return false to filter out this child
                  return false
                }

                recursiveFunc(child);
                //keep the child
                return true
              })
              //if children is an empty array, delete children property from treeData
              children.length === 0 ? delete treeData.children : treeData.children = children
            }
            return treeData
          };
            const filteredTreeviewState = recursiveFunc({children: treeviewState}).children;

            //filteredTreeviewState.sort((a,b) => a.title > b.title || a.type == 'vault' ? 1 : -1);

            return {
            ...state,
            treeData: filteredTreeviewState
            };
        }
        case POST_TREEVIEW_CHANGE_SUCCESS:
            const treeChangeState = {...state};
            treeChangeState.treeData = {};
            return {
                ...treeChangeState,
                treeData: action.payload.data
            };
        case POST_TREEVIEW_CHANGE_FAIL:
            return {
                ...state
            };
        case NEW_TREEVIEW_NODE_SUCCESS:
            return {
                ...state
            };
        case NODE_EXPANDED_SUCCESS:
            return {
                ...state
            };
        case NODE_INCLUDELOWERRECORDS_SUCCESS:
            const includeLowerRecordsState = {...state};
            includeLowerRecordsState.treeData = {};
            return {
                ...includeLowerRecordsState,
                treeData: action.payload.data
            };
        case NODE_RENAMED_SUCCESS:
            const renameState = {...state};
            renameState.treeData = {};
            return {
                ...renameState,
                treeData: action.payload.data
            };
        case NODE_RENAMED_FAIL:
            return {
                ...state
            };
        case REMOVE_TREEVIEW_NODE_SUCCESS:
            return {
                ...state
            };
        case GET_NODE_NOTE_SUCCESS:
            const noteState = {...state};
            noteState.originalNote = "";
            return {
                ...noteState,
                originalNote: action.payload.data
            };
        case ADD_NODE_NOTE_SUCCESS:
            return {
                ...state
            };
        case LOWER_RECORDS_CHECKED:
            return {
                ...state,
                lowerRecordsChecked: action.payload.data.checked
            }
        case SET_NODE_IDS:
            return {
                ...state,
                nodeSelectedIds: action.payload.data.nodeIds
            }
        case TREEVIEW_EDIT_JOB_SET:
            return {
                ...state,
                editTreeviewJobId: action.payload.data.jobId
            }
        case TREEVIEW_EDIT_JOB_RESET:
            return {
                ...state,
                editTreeviewJobId: -1
            }
        case SET_JOBS_TABLE_CHANGED:
            return {
                ...state,
                jobsTableChanged: action.payload.data.jobsTableChanged
            }
        case SET_MONITORING_JOBS_TABLE_CHANGE:
            return {
                ...state,
                monitoringJobsTableChange: action.payload.data.monitoringJobsTableChange
            }
        default:
            return state;
    }
}
